import ArrowIcon from "$/lib/icons/ArrowIcon";
import type { IndicatorType } from "$/lib/types/api/market-monitoring/market-monitoring.types";
import type { ThemeChoices } from "$/lib/types/General.types";
import { cn } from "$/lib/utils/functions/misc.functions";
import Flexbox from "../../common/Flexbox";
import AreaGraph from "../../graphs/AreaGraph";
import AreaGraphWidgetTooltip from "./AreaGraphWidgetTooltip";

interface Props {
  theme?: ThemeChoices;
  indicator: IndicatorType;
  hasChart: boolean;
  asMain: boolean;
}

const AreaGraphWidget = ({
  theme = "blue",
  indicator,
  hasChart,
  asMain,
}: Props) => {
  const {
    value,
    // secondValue,
    label,
    differenceWithSecondValue,
    differencePercentage,
    // currentDate,
    // secondDate,
    data,
  } = indicator;

  return (
    <Flexbox row fullHeight className="gap-1">
      <AreaGraphWidgetTooltip
        className="h-full w-full"
        text="Par rapport à J-1"
      >
        <Flexbox
          fullHeight
          className={cn("w-full grow gap-2", { "gap-0": !asMain })}
        >
          <h4
            className={cn("h-[5ch] text-base font-bold", {
              "text-secondary": theme === "blue",
              "text-forest": theme === "green",
              "text-warning": theme === "orange",
              "h-[4ch] text-xl": !asMain,
            })}
          >
            {label}
          </h4>

          <Flexbox className="gap-1">
            <p
              className={cn("text-base font-bold text-black", {
                "text-xl": !asMain,
              })}
            >
              {value ? `${value} €/MWh` : "-"}
            </p>
            <Flexbox row align="center" className="gap-1">
              <div
                className={cn("rounded-full p-2", {
                  "bg-forest-100":
                    differencePercentage && differencePercentage >= 0,
                  "bg-error-100":
                    differencePercentage && differencePercentage < 0,
                  "bg-[#BCBCBC1A]": !differencePercentage,
                })}
              >
                <ArrowIcon
                  className={cn({
                    "-rotate-90 [&_path]:!stroke-success-800":
                      differencePercentage && differencePercentage >= 0,
                    "rotate-90 [&_path]:!stroke-error-800":
                      differencePercentage && differencePercentage < 0,
                    "-rotate-90 [&_path]:!stroke-[#BCBCBC]":
                      !differencePercentage,
                  })}
                />
              </div>
              <p
                className={cn("text-sm font-semibold", {
                  "text-forest-800":
                    differencePercentage && differencePercentage >= 0,
                  "text-error-800":
                    differencePercentage && differencePercentage < 0,
                  "text-[#BCBCBC]": !differencePercentage,
                  "text-lg": !asMain,
                })}
              >
                <span className="whitespace-nowrap">
                  {differenceWithSecondValue
                    ? `${differenceWithSecondValue} €/MWh`
                    : "0.00 €/MWh"}
                </span>{" "}
                <span className="whitespace-nowrap">
                  {differencePercentage
                    ? `(${
                        differencePercentage <= 0 ? "+" : "-"
                      } ${Math.abs(differencePercentage)}%)`
                    : ""}
                </span>
              </p>
            </Flexbox>
          </Flexbox>
        </Flexbox>
      </AreaGraphWidgetTooltip>
      {hasChart && <AreaGraph theme={theme} data={data ?? []} />}
    </Flexbox>
  );
};

export default AreaGraphWidget;
